const MediaDirection = {
  INACTIVE: 'inactive',
  RECVONLY: 'recvonly',
  SENDONLY: 'sendonly',
  SENDRECV: 'sendrecv',
};

export default MediaDirection;
